import { render, staticRenderFns } from "./Positions.vue?vue&type=template&id=6dd3cdf4"
import script from "./Positions.vue?vue&type=script&lang=ts"
export * from "./Positions.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports